import { NavBarLinks } from "@/jbi-shared/types/navbar.types";
import { CreateElement } from "vue";

export const navbarLinks: NavBarLinks[] = [
    {
        to: '/overview',
        label: 'Overview',
    },
    {
        to: '/protocol',
        label: 'Protocol',
    },
    {
        to: '/screening',
        label: 'Screening',
    },
    {
        to: '/appraisals',
        label: 'Appraisal',
    },
    {
        to: '/extractions',
        label: 'Extraction',
    },
    {
        to: '/synthesis',
        label: 'Synthesis',
        children: [
            { to: '/synthesis/qualitative/studies', label: 'Qualitative' },
            { to: '/synthesis/meta-analysis', label: 'Comparative Meta-Analysis' },
            { to: '/synthesis/meta-analysis/singular', label: 'Proportional Meta-Analysis' },
        ],
    },
    {
        to: '/review',
        label: 'Review',
    },
]

export const screeningNavbarLinks: NavBarLinks[] = [
    {
        to: '/awaiting-screening',
        label: 'Awaiting Screening',
    },
    {
        to: '/included',
        label: 'Included',
    },
    {
        to: '/excluded',
        label: 'Excluded',
    },
    {
        to: '/resolved',
        label: 'Resolved',
    },
    {
        to: '/conflicted',
        label: 'Conflicted',
    },
    {
        to: '/my-decisions',
        label: 'My Decisions',
    },
]

export const renderChildComponent = {
    render(childView: CreateElement) {
        return childView('router-view');
    }
}
